import { useEffect, useState } from "react";

import { toast } from 'react-toastify';
import { useTogglePassword } from "../../../Components/secure/PasswordHook";
import { useAppDispatch } from "../../../Redux/store";
import {
    ButtonPasswordIcon,
    ContainerIncludeValidation,
    ContainerInput,
    ContainerInputPassword,
    ErrorTextUser,
    IndicatorPassword,
    SignUpListItem,
    SignUpModelContainer,
    SubmitFormButton,
    TextInput
} from "../../../Components/Public/WelcomePage/Header/SignUpModel/SignUpModelStyles.styled";
import { signUp } from "../../../Redux/Auth/operations";
import { FormErrorsSignUp } from "../../../Types/TypeErrors";
import { EmailUserIcon, UserIcon } from "../../../Components/Public/WelcomePage/Header/SignUpModel/setPublicIcons";
import { useNavigate } from "react-router-dom";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";

// add reCAPTCHA []

export const SignUpForm = () => {
    const { t } = useLanguageContext();
    const [nameUserSignUp, setNameSignUp] = useState(() => {
        const saved = localStorage.getItem("form-data");
        return saved ? JSON.parse(saved).name || "" : "";
    });

    
    const [emailUserSignUp, setEmailUserSignUp] = useState(() => {
        const saved = localStorage.getItem("form-data");
        return saved ? JSON.parse(saved).email || "" : "";
    });

    const [passwordUserSignUp, setPasswordUserSignUp] = useState("");
    const [confirmPasswordUserSignUp, setConfirmPasswordUserSignUp] = useState("");
    const [formErrorsSignUp, setFormErrorsSignUp] = useState<FormErrorsSignUp>({});
    const dispatch = useAppDispatch();
    const router = useNavigate();

    const enterPassword = useTogglePassword();
    const repeatPasswordToggle = useTogglePassword();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [hasTriedSubmit, setHasTriedSubmit] = useState(false);

    interface PasswordStrength {
        label: string;
        value: number;
        color: string;
    }
    const [strength, setStrength] = useState<PasswordStrength | null>(null);

    const evaluatePasswordStrength = (password: string) => {
        let score = 0;

        if (password.length >= 8) score++;
        if (password.length >= 12) score++;
        if (/[A-Z]/.test(password)) score++;
        if (/[a-z]/.test(password)) score++;
        if (/\d/.test(password)) score++;
        if (/[^A-Za-z0-9]/.test(password)) score++;

        if (score <= 2) {
            return { label: t("passwordInducator.strengthWeak"), value: 25, color: "#ff4d4d" }; // red
        }

        if (score <= 4) {
            return { label: t("passwordInducator.strengthMedium"), value: 50, color: "#ffa600" }; // orange
        }

        if (score === 5) {
            return { label: t("passwordInducator.strengthStrong"), value: 75, color: "#0099ff" }; // blue
        }

        return { label: t("passwordInducator.strengthStronger"), value: 100, color: "#00cc66" }; // green
    };

    const SignUpUser = async (evt: React.FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
        setHasTriedSubmit(true);
        setIsLoading(true);

        const form = evt.currentTarget;
        const formData = new FormData(form);
        const name = formData.get('name') as string;
        const email = formData.get('email') as string;
        const password = formData.get('password') as string;
        const confirmPassword = formData.get('confirmPassword') as string;

         const formDataUser = {
            name: nameUserSignUp.trim(),
            email: emailUserSignUp.trim(),
             password: passwordUserSignUp.trim(),
            confirmPasswordUser: confirmPasswordUserSignUp.trim()
        };

        localStorage.setItem("form-data", JSON.stringify(formDataUser));

        try {
            const signUpUser = await dispatch(
                signUp({ name, email, password, confirmPassword })
            ).unwrap();

            router(`/home-page/${signUpUser?.name.toLowerCase()}`, {
                state: {
                    openConfirmEmailModal: true
                },
            });

            clearLocalStorage("form-data");

        } catch (err) {
            console.log("Unwrapped error:", err);
            
            if (typeof err === 'object' && err !== null) {
                const typedError = err as FormErrorsSignUp;
                setFormErrorsSignUp(typedError);

            } else {
                setFormErrorsSignUp({});
                toast.error("An unknown error occurred during sign up.");
            }
        }   finally {
            setIsLoading(false); // закінчуємо loader
        }

    };

    const clearLocalStorage = (nameKey: string) => {
        localStorage.removeItem(nameKey);
    }

    useEffect(() => {
        localStorage.getItem("form-data");
        setFormErrorsSignUp({});
        clearLocalStorage("form-data");

    }, [
        nameUserSignUp,
        emailUserSignUp,
        passwordUserSignUp,
        confirmPasswordUserSignUp
    ]);

    return (
        <>
                <SignUpModelContainer>
                    <form onSubmit={SignUpUser}>
                        <ul>
                            <SignUpListItem>
                                <ContainerInput className={formErrorsSignUp.name && hasTriedSubmit ? "error-animation-input" : ""}>
                                <TextInput
                                    onChange={(evt) => {
                                        setNameSignUp(evt.target.value);
                                    }}
                                    type="text"
                                    name="name"
                                    placeholder={t("publicTranslate.FormsAndModel.ModelSignUp.InputName")}
                                    value={nameUserSignUp}
                                    
                                />
                                <UserIcon />
                            </ContainerInput>
                            <ErrorTextUser className={formErrorsSignUp.name && hasTriedSubmit ? "error-animation" : ""}>
                                {formErrorsSignUp.name}
                            </ErrorTextUser>
                            </SignUpListItem>
                            <SignUpListItem>
                               <ContainerInput className={formErrorsSignUp.email && hasTriedSubmit ? "error-animation-input" : ""}>
                                <TextInput
                                    onChange={(evt) => {
                                        setEmailUserSignUp(evt.target.value);
                                    }}
                                    type="email"
                                    name="email"
                                    placeholder={t("publicTranslate.FormsAndModel.ModelSignUp.InputEmail")}
                                    value={emailUserSignUp}
                                    
                                />
                                    <EmailUserIcon />
                            </ContainerInput>
                            <ErrorTextUser
                                className={formErrorsSignUp.email && hasTriedSubmit ? "error-animation" : ""}>
                                {formErrorsSignUp.email}
                            </ErrorTextUser>
                            </SignUpListItem>
                            <SignUpListItem>
                                <ContainerInput className={formErrorsSignUp.password && hasTriedSubmit ? "error-animation-input" : ""}>
                                    <TextInput
                                        onChange={(evt) => {
                                            const value = evt.target.value;
                                            setPasswordUserSignUp(value);

                                            if (!value) {
                                                setStrength(null); // ✅ повертаємо білу смужку
                                                return;
                                            }

                                            const strengthValue = evaluatePasswordStrength(value);
                                            setStrength(strengthValue);

                                            setFormErrorsSignUp(prev => ({ ...prev, password: "" }));
                                        }}
                                        type={enterPassword.type}
                                        name="password"
                                        placeholder={t("publicTranslate.FormsAndModel.ModelSignUp.InputPassword")}
                                        value={passwordUserSignUp}
                                    />
                                    <ButtonPasswordIcon type="button" onClick={enterPassword.toggle}>
                                        {enterPassword.icon}
                                    </ButtonPasswordIcon>
                            </ContainerInput>
                            <ErrorTextUser className={formErrorsSignUp.password && hasTriedSubmit ? "error-animation" : ""}>
                                {formErrorsSignUp.password}
                            </ErrorTextUser>
                            <ContainerIncludeValidation>
                                <IndicatorPassword
                                    width={strength?.value || 0}
                                    color={strength?.color || "#fff"}
                                >
                                </IndicatorPassword>
                                <span>{strength?.label || ""}</span>
                                <span>{t("publicTranslate.FormsAndModel.ModelSignUp.RecommendationText")} {t("publicTranslate.FormsAndModel.ModelSignUp.RecomendationTitle")}</span>
                            </ContainerIncludeValidation>
                            </SignUpListItem>
                        </ul>
                        <ContainerInputPassword className={formErrorsSignUp.confirmPassword && hasTriedSubmit ? "error-animation-input" : ""}>
                        <TextInput
                            onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                                const value = evt.target.value;
                                setConfirmPasswordUserSignUp(value);
                                setFormErrorsSignUp(prev => ({
                                    ...prev,
                                    confirmPassword: value ? "" : prev.confirmPassword
                                }));
                            }}
                            type={repeatPasswordToggle.type}
                            name="confirmPassword"
                            placeholder={t("publicTranslate.FormsAndModel.ModelSignUp.InputConfirmPassword")}
                            value={confirmPasswordUserSignUp}
                        />
                            <ButtonPasswordIcon type="button" onClick={repeatPasswordToggle.toggle}>
                                {repeatPasswordToggle.icon}
                            </ButtonPasswordIcon>
                        </ContainerInputPassword>
                        <ErrorTextUser className={formErrorsSignUp.confirmPassword && hasTriedSubmit ? "error-animation" : ""}>
                            {formErrorsSignUp.confirmPassword}
                        </ErrorTextUser>
                    <SubmitFormButton
                        type="submit"
                        value={t("publicTranslate.FormsAndModel.ModelSignUp.ButtonSignUp")}
                        disabled={isLoading}
                    />
                    </form>
                </SignUpModelContainer>
        </>
    )
}